<template>
  <draggable
    class="list-group"
    :list="data"
    :disabled="add"
    ghost-class="ghost">
    <div
      v-for="(item, index) in data"
      :key="item.id"
      class="list-group-item"
      :style="!add ? 'cursor: move;' : ''">
      <dara-article-card-list
        v-if="type === 'article'"
        :article="item"
        :index="index"
        :add="add"
        @addOrRemove="addOrRemove($event)">
      </dara-article-card-list>
    </div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';
import DaraArticleCardList from '@/modules/article/components/ArticleCardList.vue';

export default {
  name: 'DaraDraggable',
  components: {
    DaraArticleCardList,
    draggable,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'article',
    },
    add: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    addOrRemove(indexOrArticle) {
      this.$emit('addOrRemove', indexOrArticle);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/variables/colors';
  .ghost {
    background: $primary-light;
  }
</style>
